/**
 * Animation controller for temporal progression
 */
export class Animator {
  constructor(yearRange, onTick) {
    this.yearRange = yearRange;
    this.onTick = onTick;
    this.isPlaying = false;
    this.delay = 1000; // ms per tick (default 1 second)
    this.stepSize = 1; // years per tick (default 1 year)
    this.intervalId = null;
  }

  play(startYear, windowSize) {
    if (this.isPlaying) return;

    this.isPlaying = true;
    this.currentYear = startYear;
    this.windowSize = windowSize;

    this.intervalId = setInterval(() => {
      this.currentYear += this.stepSize;

      // Loop back to start if we reach the end
      if (this.currentYear + this.windowSize > this.yearRange[1]) {
        this.currentYear = this.yearRange[0];
      }

      this.onTick(this.currentYear);
    }, this.delay);
  }

  pause() {
    if (!this.isPlaying) return;

    this.isPlaying = false;
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  setDelay(delayInSeconds) {
    this.delay = delayInSeconds * 1000; // Convert to milliseconds

    // Restart animation if currently playing
    if (this.isPlaying) {
      this.pause();
      this.play(this.currentYear, this.windowSize);
    }
  }

  setStepSize(stepSize) {
    this.stepSize = stepSize;
  }
}
